<div class="graphic">
    <canvas
        baseChart
        class="graphic"
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [legend]="barChartLegend"
        [chartType]="barChartType"
    >
    </canvas>
</div>
